export default __webpack_public_path__ + "static/media/downArrowGrey.eddcd2e6.svg";